export const ROOT_ROUTES = {
  INDEX: "index",
  WELCOME: "welcome",
  SIGNUP: "signup",
  SIGNIN: "signin",
  FORGOT_PASSWORD: "forgot-password",
  TABS: "(tabs)",
  FILE_SIGN: "file/sign",
  FILE_OUT_OF_FREE_CLAIMS: "file/out-of-free-claims",
  SUBSCRIPTION_UPGRADE: "subscription/upgrade",
  SUBSCRIPTION_DETAIL: "subscription/detail",
  SUBSCRIPTION_SETUP: "subscription/setup",
  SUBSCRIPTION_SUCCESS: "subscription/success",
  MY_MONEY_SETUP: "my-money/setup",
  MY_MONEY_ANALYZING: "my-money/analyzing",
  MY_MONEY_SETUP_INCOME: "my-money/setup-income",
  MY_MONEY_SET_BUDGET: "my-money/set-budget",
  UNCLAIMED_SETUP: "unclaimed/setup",
  CONFIGURATION: "configuration",
  REFER: "refer",
  ACCOUNT: "account",
  BILLS: "bills",
  OFFERS: "offers",
  NOT_FOUND: "+not-found",
  EMAIL_UNSUBSCRIBE: "email",
  PAYMENT: "payment",
  REGISTER_PAYMENT_METHOD: "payment/register-method",
  OFFERS_SUCCESS: "offers/success",
  ADMIN: "admin",
  ADMIN_PAYOUT: "admin/payout",
  CHAT: "chat",
};

export const ROOT_ROUTES_WEB = {
  INDEX: "index",
  TABS: "(tabs)",
  FILE_SIGN: "file/sign",
  SUBSCRIPTION_DETAIL: "subscription/detail",
  MY_MONEY_SETUP: "my-money/setup",
  MY_MONEY_ANALYZING: "my-money/analyzing",
  MY_MONEY_SETUP_INCOME: "my-money/setup-income",
  MY_MONEY_SET_BUDGET: "my-money/set-budget",
  UNCLAIMED_SETUP: "unclaimed/setup",
  CONFIGURATION: "configuration",
  REFER: "refer",
  ACCOUNT: "account",
  BILLS: "bills",
  EMAIL_UNSUBSCRIBE: "email",
  OFFERS: "offers",
  PAYMENT: "payment",
  REGISTER_PAYMENT_METHOD: "payment/register-method",
  OFFERS_SUCCESS: "offers/success",
  ADMIN: "admin",
  ADMIN_PAYOUT: "admin/payout",
  CHAT: "chat",
};
